import { render, staticRenderFns } from "./Sustainability.vue?vue&type=template&id=609e7590&"
import script from "./Sustainability.vue?vue&type=script&lang=js&"
export * from "./Sustainability.vue?vue&type=script&lang=js&"
import style0 from "./Sustainability.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {YouTubeOrImage: require('/gitlab-runner-data/builds/ns-am/product/apps/catalog/components/YouTubeOrImage.vue').default})
